<body class="clear-security-screening">
  <div class="clear-security-screening-container">
    <h3 class="page-title">{{ CONST.HEADER }}</h3>
    <app-security-screening-form></app-security-screening-form>

    <!-- Table -->
    <div class="clear-security-screening-table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        id="excel-table"
        class="clear-security-screening-table"
      >
        <caption>
          Clear Security Screening
        </caption>

        <!-- TRACKING_NUMBER -->
        <ng-container matColumnDef="trackingNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="tracking-number-headers"
            class="column-left-alignment width-20"
          >
            <app-table-search-component
              [columnName]="COLUMNTEXT.TRACKING_NUMBER"
              [placeholder]="CONST.SEARCH"
              [control]="trackingNumberData.formControl"
              [maxLength]="18"
              [textInputWidth]="240"
              [searchIconOffset]="82"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="tracking-number-headers"
            class="selectable cursor-pointer tracking-number-cell"
            mat-cell
            *matCellDef="let clearSecurityScreening; let i = index"
          >
            {{ clearSecurityScreening.trackingNumber }}
          </td>
        </ng-container>

        <!-- SCREENING_TYPE -->
        <ng-container matColumnDef="screeningType">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="screening-type-headers"
            class="screening-type"
            [ngClass]="{ 'width-20': true }"
          >
            <app-table-header-dropdown
              [columnText]="COLUMNTEXT.SCREENING_TYPE"
              [textInputWidth]="153"
              [itemId]="screeningTypeData.itemId"
              [resetData]="resetSelectDropdowns"
              [searchResults]="screeningTypeOption"
              [showDropdown]="dropdownOpen[0]"
              (dropdownChange)="
                dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
              "
              (checkboxesUpdated)="
                onStatusChangeForDropdowns($event, screeningTypeData)
              "
              [popoverStyle]="{ maxWidth: 153, offsetX: -110 }"
            >
            </app-table-header-dropdown>
          </th>

          <td
            headers="departDate-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let clearSecurityScreening; let i = index"
          >
            {{ clearSecurityScreening.screeningType }}
          </td>
        </ng-container>

        <!-- SCREENING_METHOD -->
        <ng-container matColumnDef="screeningMethod">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="screening-method-headers"
            class="screening-method"
            [ngClass]="{ 'width-20': true }"
          >
            <!-- [itemId]="screeningTypeData.itemId"
          [resetData]="resetSelectDropdowns"
          [searchResults]="screeningTypeOption"
          [showDropdown]="dropdownOpen[0]"
          (dropdownChange)="
            dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
          "
          (checkboxesUpdated)="
            onStatusChangeForDropdowns($event, screeningTypeData)
          " -->
            <app-table-header-dropdown
              [columnText]="COLUMNTEXT.SCREENING_METHOD"
              [textInputWidth]="207"
              [itemId]="screeningMethodData.itemId"
              [resetData]="resetSelectDropdowns"
              [searchResults]="screeningMethodOption"
              [showDropdown]="dropdownOpen[1]"
              (dropdownChange)="
                dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
              "
              (checkboxesUpdated)="
                onStatusChangeForDropdowns($event, screeningMethodData)
              "
              [popoverStyle]="{ maxWidth: 210, offsetX: -160 }"
            >
            </app-table-header-dropdown>
          </th>

          <td
            headers="departDate-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let clearSecurityScreening; let i = index"
          >
            {{ clearSecurityScreening.screeningMethod }}
          </td>
        </ng-container>

        <!-- SCREENER_ID -->
        <ng-container matColumnDef="screenerID">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="screening-id-headers"
            class="screening-id"
            [ngClass]="{ 'width-20': true }"
          >
            <app-table-search-component
              [columnName]="COLUMNTEXT.SCREENER_ID"
              [placeholder]="CONST.SEARCH"
              [control]="screenerIdData.formControl"
              [maxLength]="18"
              [textInputWidth]="180"
              [searchIconOffset]="52"
              (emitSearch)="search()"
            ></app-table-search-component>
          </th>

          <td
            headers="departDate-headers"
            class="selectable cursor-pointer"
            mat-cell
            *matCellDef="let clearSecurityScreening; let i = index"
          >
            {{ clearSecurityScreening.screenerID }}
          </td>
        </ng-container>

        <!-- SECONDARY_SCREENING -->
        <ng-container matColumnDef="secondaryScreening">
          <th
            mat-header-cell
            *matHeaderCellDef
            id="secondary-screening-headers"
            class="secondary-screening"
            [ngClass]="{ 'width-20': true }"
          >
            <app-table-dropdown-status
              [header]="COLUMNTEXT.SECONDARY_SCREENING"
              [data]="secondaryScreeningData"
              [resetData]="resetSelectDropdowns"
              [showDropdown]="dropdownOpen[2]"
              (dropdownChange)="
                dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 2)
              "
              (emitStatusChange)="
                onStatusChangeForDropdowns($event, secondaryScreeningData)
              "
            >
            </app-table-dropdown-status>
          </th>

          <td
            mat-cell
            *matCellDef="let clearSecurityScreening; let i = index"
            headers="status-headers"
            class="status-data-column"
          >
            <ion-icon
              [src]="
                clearSecurityScreening.secondaryScreening
                  ? IMAGE.ACTIVE
                  : IMAGE.CANCEL
              "
              class="status-icon"
              [class.cancel-icon]="!clearSecurityScreening.secondaryScreening"
            >
            </ion-icon>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = dataIndex"
        ></tr>

        <tr class="mat-row" *matNoDataRow>
          <td
            class="mat-cell no-border no-results"
            [attr.colspan]="displayedColumns.length"
          >
            <app-no-results-found></app-no-results-found>
          </td>
        </tr>
      </table>
    </div>
  </div>
</body>
